/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusEmailVorlageListResponseDto } from '../../models/lexplus-email-vorlage-list-response-dto';

export interface EmailTemplateControllerFindAllV1$Params {

/**
 * Page number to retrieve. If you provide invalid value the default page number will applied
 *
 * **Example:** 1
 *
 *
 * **Default Value:** 1
 */
  page?: number;

/**
 * Number of records per page.
 *
 *
 * **Example:** 20
 *
 *
 *
 * **Default Value:** 25
 *
 *
 *
 * **Max Value:** 100
 *
 *
 * If provided value is greater than max value, max value will be applied.
 */
  limit?: number;

/**
 * Filter by kategorie query param.
 *
 * **Format:** filter.kategorie={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.kategorie=$eq:John Doe&filter.kategorie=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $and
 *
 * - $or
 */
  'filter.kategorie'?: Array<string>;

/**
 * Filter by status query param.
 *
 * **Format:** filter.status={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.status=$eq:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $and
 *
 * - $or
 */
  'filter.status'?: Array<string>;

/**
 * Parameter to sort by.
 * To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting
 *
 * **Format:** {fieldName}:{DIRECTION}
 *
 *
 * **Example:** sortBy=name:DESC&sortBy=kategorie:DESC
 *
 *
 * **Default Value:** name:ASC
 *
 * **Available Fields**
 * - name
 *
 * - kategorie
 *
 * - status
 *
 * - bearbeitetAm
 *
 * - erstelltAm
 */
  sortBy?: Array<'name:ASC' | 'name:DESC' | 'kategorie:ASC' | 'kategorie:DESC' | 'status:ASC' | 'status:DESC' | 'bearbeitetAm:ASC' | 'bearbeitetAm:DESC' | 'erstelltAm:ASC' | 'erstelltAm:DESC'>;

/**
 * Search term to filter result values
 *
 * **Example:** John
 *
 *
 * **Default Value:** No default value
 */
  search?: string;

/**
 * List of fields to search by term to filter result values
 *
 * **Example:** name
 *
 *
 * **Default Value:** By default all fields mentioned below will be used to search by term
 *
 * **Available Fields**
 * - name
 */
  searchBy?: Array<string>;

/**
 * List of fields to select.
 *
 * **Example:** emailVorlageID,name,kategorie,status,bearbeitetAm
 *
 *
 * **Default Value:** By default all fields returns. If you want to select only some fields, provide them in query param
 */
  select?: string;
}

export function emailTemplateControllerFindAllV1(http: HttpClient, rootUrl: string, params?: EmailTemplateControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusEmailVorlageListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, emailTemplateControllerFindAllV1.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('filter.kategorie', params['filter.kategorie'], {});
    rb.query('filter.status', params['filter.status'], {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('search', params.search, {});
    rb.query('searchBy', params.searchBy, {});
    rb.query('select', params.select, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusEmailVorlageListResponseDto>;
    })
  );
}

emailTemplateControllerFindAllV1.PATH = '/v1/email-templates';
